export default __webpack_public_path__ + "images/Teriyaki.c40692.jpg";